import { useCallback, useMemo } from 'react';

import Logger from 'common/services/Logger/Logger';

import useCustomer from '../useCustomer';
import { CustomerLocationTracker, UserActivityType } from './CustomerLocationTracker';
import { SmartlookEventTracker, SmartlookEventTypes, SmartlookParamsType } from './SmartlookEventTracker';

export type ActionTypes = SmartlookEventTypes | UserActivityType;
export type ActionParams = SmartlookParamsType;

const trackingLogger = new Logger('TRACK');

const useTracking = () => {
  const handlers = useMemo(() => [new CustomerLocationTracker(), new SmartlookEventTracker()], []);

  const { isAuthenticated } = useCustomer();

  const track = useCallback(
    (action: ActionTypes, eventParams?: ActionParams): void => {
      handlers.forEach((handler) => {
        if (isAuthenticated) {
          trackingLogger.success(action);
          handler.process(action, eventParams);
        }
      });
    },
    [handlers, isAuthenticated],
  );

  return { track };
};

export default useTracking;
